// customElements.ts
import LoftShadowDOM from './LoftShadowDom';

if (!customElements.get('html-loft')) {
  customElements.define('html-loft', LoftShadowDOM);
}
